import { getToolName, isToolUIPart, type UIMessage } from "ai";

export type HelpSource = { kind: string; slug: string; title: string; summary: string; url: string };

const record = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" && !Array.isArray(value) ? (value as Record<string, unknown>) : {};

const asSource = (value: unknown): HelpSource | null => {
  const row = record(value);
  return typeof row.url === "string" && typeof row.title === "string"
    ? {
        kind: String(row.kind ?? "guide"),
        slug: String(row.slug ?? ""),
        title: row.title,
        summary: typeof row.summary === "string" ? row.summary : "",
        url: row.url,
      }
    : null;
};

const HELP_TOOLS = new Set([
  "searchHelpArticlesTool",
  "search-help-articles",
  "getHelpArticleTool",
  "get-help-article",
]);

/**
 * Materiały, które agent faktycznie podał w odpowiedzi (link z ich adresem w tekście).
 * Wyniki wyszukiwania, po których nie sięgnął, nie trafiają na karty.
 */
export const citedHelpSources = (message: UIMessage): HelpSource[] => {
  const text = message.parts.map((part) => (part.type === "text" ? part.text : "")).join("\n");
  const byUrl = new Map<string, HelpSource>();
  for (const part of message.parts) {
    if (!isToolUIPart(part) || part.state !== "output-available" || !HELP_TOOLS.has(getToolName(part))) continue;
    const output = record(part.output);
    const candidates = Array.isArray(output.results) ? output.results : output.article ? [output.article] : [];
    for (const candidate of candidates) {
      const source = asSource(candidate);
      if (source && text.includes(source.url)) byUrl.set(source.url, source);
    }
  }
  return [...byUrl.values()];
};
